// Import React libs
import React from "react";
import { Routes, Route } from "react-router-dom";
// Import Pages
import Home from "./Pages/Home";
import NotFound from "./Pages/NotFound";
import Docs from "./Pages/Docs";
import AssetsBook from "./Pages/AssetsBook";
import Regulation from "./Docs/Regulation";
import Policy from "./Docs/Policy";
import Streams1 from "./Streams/Streams1";
import Streams2 from "./Streams/Streams2";
// Import Css
import './Assets/Css/Reset.css'
import './Assets/Css/Global.css'
// Import Components
import Header from "./Components/Header/Header";
import Footer from "./Components/Footer/Footer";
const App = () => {
  return(
    <div>
        <Routes>
          <Route path="/*" element={<NotFound />}/>
          <Route path="/" element={<Home />}/>
          <Route path="/Home" element={<Home />}/>
          <Route path="/Docs" element={<Docs />}/>
          <Route path="/AssetsBook" element={<AssetsBook />}/>
          <Route path="/Regulation" element={<Regulation />}/>
          <Route path="/Policy" element={<Policy />}/>
          <Route path="/Streams1" element={<Streams1 />}/>
          <Route path="/Streams2" element={<Streams2 />}/>
        </Routes>
        <Footer />       
    </div>
  );
}
export default App